import React from 'react';
// import { authRoles } from '../../store/auth'; // ** Important**

const PlayerConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: true,
        },
        footer: {
          display: true,
        },
      },
    },
  },
  // auth: authRoles.user, // ** Important**
  routes: [
    {
      path: '/watch',
      component: React.lazy(() => import('./Player')),
    },
  ],
};

export default PlayerConfig;
